import React from 'react'

export default function SMSCampaign() {
  return (
    <div>
      <h1>SMS Campaign</h1>
    </div>
  )
}
